(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-bestseller"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // ── Wishlist toggle ──
  document.querySelectorAll('.petcozy-card__wishlist').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.toggle('is-active');
      var label = btn.getAttribute('aria-label') || '';
      if (btn.classList.contains('is-active')) {
        btn.setAttribute('aria-label', label.replace('Add', 'Remove'));
      } else {
        btn.setAttribute('aria-label', label.replace('Remove', 'Add'));
      }
    });
  });

  // ── Ajax Add to Cart ──
  document.querySelectorAll('.petcozy-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.petcozy-card__atc');
      if (!btn || btn.disabled) return;

      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<svg style="width:18px;height:18px;animation:spin .7s linear infinite" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('input[name="id"]').value,
          quantity: 1
        })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.innerHTML = '<svg style="width:16px;height:16px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Added!';
        // refresh cart drawer/bubble if theme supports it
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        btn.innerHTML = 'Error — try again';
        setTimeout(function () {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 2200);
      });
    });
  });

  // ── Spinner keyframe (injected once) ──
  if (!document.getElementById('petcozy-spin-style')) {
    var style = document.createElement('style');
    style.id = 'petcozy-spin-style';
    style.textContent = '@keyframes spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
